var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout minimal"},[_c('div',{staticClass:"cont"},[_c('div',[_c('div',{staticClass:"logo-container"},[_c('router-link',{attrs:{"to":{name: 'home'}}},[_c('div',{staticClass:"logo"})])],1),_vm._t("default")],2)]),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }